/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Relay16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            d="M12.956 1h.013a.503.503 0 01.509.359l.005.022a.463.463 0 01.001.239l-.01.032a.48.48 0 01-.07.139l-2.267 3.633 3.692 3.7c.103.09.16.211.17.337L15 9.5a.5.5 0 01-.532.499l-.043.001H4.306l1.17 4.349a.5.5 0 01-.241.593l-.083.035a.5.5 0 01-.628-.325l-3.5-13A.506.506 0 011 1.5l.006.077a.497.497 0 01-.005-.05L1 1.5a.47.47 0 01.01-.097A.498.498 0 011.531 1h.013zM7.095 2H2.152l1.885 7.002L4.075 9h4.219L5.187 5.89a.5.5 0 01-.14-.603l.046-.077L7.095 2zm5.002 0H8.271L6.135 5.424 9.704 9h3.592l-3.107-3.11a.5.5 0 01-.14-.603l.046-.077L12.097 2z"
        />
    </AccessibleSVG>
);

export default Relay16;
